module.exports = __webpack_public_path__ + "static/Maithili-cb1201eb1fd6b31ba370539a9a81df87.svg";